module.exports = __webpack_public_path__ + "img/shipIcon.0d1ae798.png";